import { CallDetailsFragment } from "@/graphql/generated/graphql";

/** Average adult reading speed used to turn a word count into minutes. */
const WORDS_PER_MINUTE = 200;

export const calculateReadingTime = (
  transcription: CallDetailsFragment["transcription"] | null
): number | undefined => {
  if (!transcription?.content?.utterances) {
    return;
  }

  let totalWords = 0;

  if (transcription.wordsCount) {
    totalWords = transcription.wordsCount;
  } else {
    for (const word of transcription.content.utterances) {
      if (word?.entries) {
        totalWords += word.entries.length;
      }
    }
  }

  return Math.round(totalWords / WORDS_PER_MINUTE) || 1;
};
